import { generateStringifyQueryParams, gtag, install } from '../helpers/GoogleAnalytic4';
import { ITrackNewAnalytics } from '../Interfaces/Events';

import Core from './SystemsCore';

export default class GoogleAnalytics4 extends Core {
    private Google: typeof gtag;
    private state: {
        isInit: boolean;
        anonymize: boolean;
        googleAdsId: string | null;
        googleAdsShopId: string | null;
    };
    public name: string;

    constructor() {
        super();
        this.name = 'ga4';
        this.Google = gtag;
        this.state = {
            isInit: false,
            anonymize: false,
            googleAdsId: null,
            googleAdsShopId: null,
        };
    }

    init({ id, config }: { id: string; config: { googleAdsId?: string; googleAdsShopId?: string } }) {
        try {
            install(id, config);
            if (config?.googleAdsId && config?.googleAdsShopId) {
                this.state.googleAdsId = config?.googleAdsId;
                this.state.googleAdsShopId = config?.googleAdsShopId;
            }

            this.state.isInit = true;
        } catch (error) {
            console.log('Google init ', error); // eslint-disable-line no-console
        }
    }

    getInit() {
        return this.state.isInit;
    }

    getABTestName() {
        return localStorage.getItem('testania_name') || '';
    }

    async trackNew({ eventName, eventAction, eventData = {} }: ITrackNewAnalytics): Promise<void> {
        const eventLabel = eventData?.event_label;
        const urlParams = await generateStringifyQueryParams();

        this.Google('event', eventName, {
            event_category: eventName,
            dimension1: this.getABTestName(),
            value: 1,
            ...(eventAction ? { event_action: eventAction } : {}),
            ...(eventLabel ? { event_label: eventLabel } : {}),
            ...(urlParams
                ? { page_location: `${window.location.origin}${window.location.pathname}?${urlParams}` }
                : {}),
        });
    }
}
